import type { TeamMember, Group } from "@/types";

export const TEAM: TeamMember[] = [
  {
    id: "1", name: "Amir Khan", email: "amir.khan@mobilelive.ca", role: "CEO", avatar: "AK", color: "#dc2626", location: "toronto", group: "leadership",
    events: [
      { start: 9, end: 10, title: "Board Prep", status: "confirmed" },
      { start: 11, end: 12, title: "Investor Call", status: "confirmed" },
      { start: 14, end: 14.5, title: "Quick Sync", status: "tentative" },
      { start: 16, end: 17, title: "Strategy Review", status: "confirmed" },
    ],
  },
  {
    id: "2", name: "Meena Raj", email: "meena.raj@mobilelive.ca", role: "President", avatar: "MR", color: "#7c3aed", location: "toronto", group: "leadership",
    events: [
      { start: 9, end: 10, title: "Morning Standup", status: "confirmed" },
      { start: 10.5, end: 11.5, title: "Product Review", status: "tentative" },
      { start: 13, end: 14, title: "Client Call", status: "confirmed" },
      { start: 15.5, end: 16.5, title: "Team 1:1", status: "tentative" },
    ],
  },
  {
    id: "3", name: "Sarah Chen", email: "sarah.chen@mobilelive.ca", role: "VP Engineering", avatar: "SC", color: "#ec4899", location: "vancouver", group: "engineering",
    events: [
      { start: 10, end: 11, title: "Arch Review", status: "confirmed" },
      { start: 14, end: 15, title: "Sprint Planning", status: "confirmed" },
    ],
  },
  {
    id: "4", name: "Marcus Johnson", email: "marcus.johnson@mobilelive.ca", role: "Engineering Manager", avatar: "MJ", color: "#f59e0b", location: "toronto", group: "engineering",
    events: [
      { start: 9, end: 9.5, title: "Daily Standup", status: "confirmed" },
      { start: 11, end: 12, title: "Code Review", status: "tentative" },
      { start: 15, end: 16, title: "1:1 with Report", status: "confirmed" },
    ],
  },
  {
    id: "5", name: "Priya Patel", email: "priya.patel@mobilelive.ca", role: "Staff Engineer", avatar: "PP", color: "#10b981", location: "mumbai", group: "engineering",
    events: [
      { start: 9, end: 10, title: "Standup", status: "confirmed" },
      { start: 12, end: 13, title: "Lunch", status: "confirmed" },
      { start: 15, end: 16.5, title: "Design Sync", status: "tentative" },
    ],
  },
  {
    id: "6", name: "Jordan Lee", email: "jordan.lee@mobilelive.ca", role: "Head of People", avatar: "JL", color: "#8b5cf6", location: "london", group: "people",
    events: [
      { start: 9, end: 10, title: "HR Standup", status: "confirmed" },
      { start: 11, end: 12, title: "Benefits Review", status: "confirmed" },
      { start: 14, end: 15, title: "Candidate Debrief", status: "tentative" },
    ],
  },
  {
    id: "7", name: "Emma Davis", email: "emma.davis@mobilelive.ca", role: "Sr. Recruiter", avatar: "ED", color: "#ef4444", location: "dubai", group: "people",
    events: [
      { start: 9, end: 10, title: "Sourcing", status: "confirmed" },
      { start: 11, end: 11.5, title: "Screen Call", status: "confirmed" },
      { start: 14, end: 15.5, title: "Panel Debrief", status: "tentative" },
    ],
  },
  {
    id: "8", name: "Raj Gupta", email: "raj.gupta@mobilelive.ca", role: "Director, Product", avatar: "RG", color: "#14b8a6", location: "singapore", group: "product",
    events: [
      { start: 9, end: 10.5, title: "Roadmap Review", status: "confirmed" },
      { start: 13, end: 14, title: "Customer Interview", status: "confirmed" },
      { start: 16, end: 17, title: "Demo Prep", status: "tentative" },
    ],
  },
  {
    id: "9", name: "Alex Kim", email: "alex.kim@mobilelive.ca", role: "Product Manager", avatar: "AKi", color: "#3b82f6", location: "toronto", group: "product",
    events: [
      { start: 10, end: 11, title: "Stakeholder Sync", status: "confirmed" },
      { start: 13.5, end: 14.5, title: "Grooming", status: "confirmed" },
    ],
  },
];

export const GROUPS: Record<string, Group> = {
  leadership: { label: "Leadership", icon: "\u{1F451}" },
  engineering: { label: "Engineering", icon: "\u2699\uFE0F" },
  people: { label: "People & Talent", icon: "\u{1F4BC}" },
  product: { label: "Product", icon: "\u{1F4E6}" },
};
